<template>
<!-- 混凝土跟踪信息 -->
    <div class="pump-box">
        <div class="box-left bg-color2">
            <el-collapse accordion style="width:100%;" v-model="activeName">
                <el-collapse-item style="flex-wrap:wrap;"  v-for="item in entList" :key="item.index" :name="item.index">
                    <template slot="title">
                        <div class="box-left-item" style="width:84%;">
                            <!-- <p class="nowrap" :title="item.entName">{{item.entName}}</p> -->
                            <p class="con" style="height:3.5vh;padding-top: 1vh;">
                                <span>{{item.num}}辆</span>
                                <img :src="require('../../../assets/image/tower'+item.index+'0.png')" style="height:5vh;position: relative;top: -0.5vh;" />
                            </p>
                            <!-- <p class="con">
                                <img src="../../../assets/image/exc.png" style="width:1vw;" />
                                <span>{{item.sum}}辆</span>
                            </p> -->
                        </div>
                    </template>
                    <div class="car-item" :class="{'cur':curCar.carNumber==child.carNumber}" v-for="(child,index) in item.car" :key="index" @click="setCurCar(child)">{{child.carNumber}}</div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div class="box-right">
            <div class="box-r-head">
                <el-button type="text">轨迹回看</el-button>
                <el-date-picker
                    v-model="time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    @change="timeChange"
                    placeholder="选择日期">
                </el-date-picker>
                <el-button type="primary" v-if="!trailDisable" @click="showTrail" style="margin-left:20px;">回看</el-button>
                <el-button type="primary" v-else style="margin-left:20px;">{{curTime}}</el-button>
                <el-button type="primary" style="margin-left:20px;" @click="speedShow">{{intervalName}}</el-button>
            </div>
            <div class="box-r-con">
                <div class="r-con-left">
                    <el-slider
                        v-model="showTime"
                        :step='1'
                        :max="1440"
                        vertical
                        :marks="timeMark"
                        height='100%'
                        :format-tooltip="formatToolTip"
                        @change="showTimeChange"
                        >
                    </el-slider>
                </div>
                <div class="r-con-map">
                    <baidu-map class="map-box" :center="center" :zoom="12" @ready="handler" @click="getClickInfo">
                        <bm-marker v-for="(item,index) in points" @click="clickHandler(item)" :key="index" :position="item.position"  :icon="{url: require('../../../assets/image/tower'+item.index+'.gif'), size: {width: 80, height: 80}}">
                        </bm-marker>
                    </baidu-map>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
export default {
    data(){
        return{
            time:util.myTime.getCurTime(),
            name:'',
            curTime:'',//当前路径的时间
            showTime:0,//路径展示开始时间
            showTimeDate:'00:00:00',
            trailDisable:false,
            map:undefined,
            center: {
                lng: 117.285033,
                lat: 31.86515
            },
            BMap:undefined,
            timesOut:undefined,
            timeMark:{
                0:'00',
                // 60:'01:00',
                // 120:'02:00',
                // 180:'03:00',
                // 240:'04:00',
                // 300:'05:00',
                360:'06',
                // 420:'07:00',
                // 480:'08:00',
                // 540:'09:00',
                // 600:'10:00',
                // 660:'11:00',
                720:'12',
                // 780:'13:00',
                // 840:'14:00',
                // 900:'15:00',
                // 960:'16:00',
                // 1020:'17:00',
                1080:'18',
                // 1140:'19:00',
                // 1200:'20:00',
                // 1260:'21:00',
                // 1320:'22:00',
                // 1380:'23:00',
                1440:'(小时)',
            },
            points:[
                // {id:"0",index:'0',position:{lng:'117.285033',lat:'31.86515'}}
            ],
            groupId:'',
            entList:[],
            curCar:{},
            entId:'',
            activeName:'0',
            worker:undefined,
            interval:100,
            intervalName:'加速',
            pointIndex:0,//当前展示的坐标点
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.entId = ''
        
    },
    methods:{
        //获取企业
        getEnt(){
            var that = this
            myHttp.selectConcreteEntStatistics({
                stationId:1
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list1 = resp.data.data.ConcreteEnt||[]
                    var list = [list1[1]]
                    for(var i=0;i<list.length;i++){
                        list[i].index = i
                        if(list[i].car.length>0){
                            for(var j=0;j<list[i].car.length;j++){
                                list[i].car[j].index = i
                            }
                        }
                    }
                    if(list.length>0){
                        that.entId = list[0].entId
                        that.curCar = list[0].car[0]
                        that.getData()
                    }
                    that.entList = list
                }
            })
        },

        //根据企业获取数字标记
        getIndexByEnt(id){
            var list = this.entList
            var result = 0
            for(var i=0;i<list.length;i++){
                if(id==list[i].entId){
                    result = list[i].index
                }
            }
            return result
        },
        
        //当前车
        setCurCar(row){
            this.curCar = row
            this.entId = row.entId
            this.points = []
            this.getData()
            // var viewPoints = []
            // this.entId = row.entId
            // row.index = this.getIndexByEnt(row.entId)
            // if(row.latitude&&row.latitude!=''&&row.longitude&&row.longitude!=''){
            //     row.position = {lng: parseFloat(row.longitude), lat: parseFloat(row.latitude)}
            //     this.points.push(row)
            //     viewPoints.push(row.position)
            // }
            // this.map.setViewport(viewPoints);
        },

        formatToolTip(val){
            let hour = 0
            let min = 0
            let ms = val * 60
            hour = parseInt(ms / 3600)
            if (hour < 10) {
                hour = '0' + hour.toString()
            } else {
                hour = hour.toString()
            }
            min = parseInt(val % 60)
            if (min < 10) {
                min = '0'+min.toString()
            } else {
                min = min.toString()
            }
            let time = hour + ':' + min
            return time
        },
        showTimeChange(e){
            var hour = parseInt(e/60)
            hour = hour<10?'0'+hour:hour
            var min = parseInt(e%60)
            min = min<10?'0'+min:min
            this.showTimeDate = hour + ':' + min+':00'
            if(this.trailDisable){
                //this.trailDisable = false
                clearInterval(this.timesOut)
            }
            this.getData()
        },

        //地图展示
        handler({ BMap, map }) {
            this.map = map
            this.BMap = BMap
            this.map.enableScrollWheelZoom();
            map.addControl(new BMap.ScaleControl());
            this.getEnt()
            // if(!this.curCar){
            //     this.getData()
            // }
            // this.getAttendArea()
            // this.getLocation()
        },

        //获取信息
        getData(){
            var that = this
            myHttp.findPathParticle({
                entId:this.entId,
                carNumber:this.curCar.carNumber,
                time:this.time+' '+this.showTimeDate,
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.clearBaiDu()
                    that.map.clearOverlays();
                    // that.showFenceArea(JSON.stringify(that.allPoint))
                    var list = resp.data.data.pkLocationReportList||[]
                    that.dataPoint = list
                    if(list.length==0){
                        that.playPoint = []
                        that.$message.error('暂无运行路线！')
                        return
                    }
                    var datas = list
                    var PointArr = [];
                    if(datas.length != 0) {
                        for(let is in datas) {
                            PointArr.push({lat:parseFloat(datas[is].latitude),lng:parseFloat(datas[is].longitude)}) ;   
                        }  
                    }else{
                        PointArr.push({lat:31.855084,lng:117.140395}) ;
                    }
                    var pois = [];//路线
                    for(let i in PointArr) {
                        pois.push(new BMap.Point(PointArr[i].lng,PointArr[i].lat));
                    }
                    that.playPoint = pois

                    //设置轨迹最后的位置
                    var worker_icon = new BMap.Icon(require('../../../assets/image/tower'+that.curCar.index+'.png'), new BMap.Size(80,80),{
                        anchor: new BMap.Size(40, 40),//这句表示图片相对于所加的点的位置mapStart
                        imageSize:new BMap.Size(80, 80) //图标所用的图片的大小，此功能的作用等同于CSS中的background-size属性。可用于实现高清屏的高清效果
                    });
                    that.worker = new BMap.Marker(pois[pois.length-1],{icon:worker_icon})
                    that.map.addOverlay(that.worker);
                    
                    if(that.trailDisable){
                        that.dingshi(pois)
                    }
                    //that.dingshi(pois)
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },

        dingshi(pois){
            //var pois = this.playPoint
            this.clearBaiDu()
            if(pois.length==0){
                this.$message.error('暂无运行路线！')
                return
            }
            //人
            if(this.worker){
                this.worker.setPosition(pois[0])
                this.map.panTo(pois[0]); 
            }else{
                var worker_icon = new BMap.Icon(require('../../../assets/image/tower'+this.curCar.index+'.png'), new BMap.Size(80,80),{
                    anchor: new BMap.Size(40, 40),//这句表示图片相对于所加的点的位置mapStart
                    imageSize:new BMap.Size(80, 80) //图标所用的图片的大小，此功能的作用等同于CSS中的background-size属性。可用于实现高清屏的高清效果
                });
                this.worker = new BMap.Marker(pois[0],{icon:worker_icon})
                this.map.addOverlay(this.worker);
            }
            
            var that = this
            this.pointIndex = 0
            this.timesOut = setInterval(() => {
                if(this.pointIndex<pois.length){
                    if(this.pointIndex==0){
                        console.log('回放开始！')
                        that.trailDisable = true
                    }
                    that.pointIndex++
                    that.curTime = that.dataPoint[that.pointIndex] && that.dataPoint[that.pointIndex].time||'回看中...'
                    that.curTime = that.curTime +'('+util.myTime.getDuration(that.dataPoint[that.pointIndex].stopTime)+')'
                    console.log(that.dataPoint[that.pointIndex].statusField)
                    that.play(that.pointIndex,pois)
                }else{
                    console.log('回放结束！')
                    that.curTime = ''
                    that.trailDisable = false
                    clearInterval(that.timesOut)
                    that.pointIndex = 0
                }
                
            }, this.interval);
            
        },

        play(index,list){
            var point = list[index];
            if(this.map.getDistance(list[index - 1],point)>100){
                this.map.panTo(point);  
            }
            // console.log(point)
            this.worker.setPosition(point)
            var rsRotation = this.getTheta(parseFloat(point.lng)-parseFloat(list[index - 1].lng),parseFloat(point.lat)-parseFloat(list[index - 1].lat))
            this.worker.setRotation(rsRotation);
            var polyline = new BMap.Polyline([list[index - 1], point], {
                enableEditing: false,//是否启用线编辑，默认为false
                enableClicking: true,//是否响应点击事件，默认为true
                // icons:[icon],
                strokeWeight:'5',//折线的宽度，以像素为单位
                strokeOpacity: 1,//折线的透明度，取值范围0 - 1
                strokeColor:"#349c00" //折线颜色
            });
            this.map.addOverlay(polyline) 
        },

        //求得转向角 dy，dx为前后经纬度之差
        getTheta(dy,dx) {
            var theta = Math.atan2(dy, dx) * 180 / Math.PI;
            if (theta < 0.0) {
                theta = 360.0 - Math.abs(theta);
            }
            return theta;
        },

        //地图点击
        getClickInfo(e){
            if(!this.curIndex){
                var allOverlay = this.map.getOverlays();
                for(var i=0;i<allOverlay.length;i++){
                    if(allOverlay[i].toString()=="[object Overlay]"){
                        this.map.removeOverlay(allOverlay[i]);
                    }
                }
            }
            this.infoWindowClose()
        },
        //关闭
        infoWindowClose(){
            this.curIndex = undefined
        },
        //点击定位人员
        clickHandler(e){
            this.curIndex = e
            this.showMapMarker(e)
        },
        //展示地图数据
        showMapMarker(obj){
            var _selt = this
            // 复杂的自定义覆盖物
            function ComplexCustomOverlay(point,obj){
                this._point = point;
                this._option = obj
            }
            ComplexCustomOverlay.prototype = new BMap.Overlay();
            ComplexCustomOverlay.prototype.initialize = function(map){
                this._map = map;
                var option = this._option;
                var div = this._div = document.createElement("div");
                div.style.position = "absolute";
                div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
                div.style.height = "120px";
                div.style.width = "180px";
                div.style.background = "rgba(19, 46, 140, 0.8)";
                div.style.borderRadius = "5px";
                div.style.padding = "10px";
                div.style.cursor = 'pointer'
                var that = this;

                //人员名称
                var nameText = document.createElement("p");
                nameText.style.position = "relative";
                nameText.style.width = "100%";
                nameText.style.height = "30px";
                nameText.style.fontSize = "12px";
                nameText.style.color = "rgba(255, 255, 255, 1)";
                nameText.style.whiteSpace = "nowrap";
                nameText.style.textOverflow = "ellipsis";
                nameText.style.overflow = "hidden";
                nameText.innerHTML = '企业：' + option.entName||'';
                nameText.title = option.personName||'';
                div.appendChild(nameText);

                // 班组
                var progressText = document.createElement("p");
                progressText.style.position = "relative";
                progressText.style.width = "100%";
                progressText.style.height = "30px";
                progressText.style.fontSize = "12px";
                progressText.style.color = "rgba(255, 255, 255, 1)";
                progressText.innerHTML = '车牌：'+ option.carNumber||''; 
                div.appendChild(progressText);

                //时间
                var addrText = document.createElement("p");
                addrText.style.position = "relative";
                addrText.style.width = "100%";
                addrText.style.height = "30px";
                addrText.style.fontSize = "12px";
                addrText.style.color = "rgba(255, 255, 255, 1)";
                addrText.style.whiteSpace = "nowrap";
                addrText.style.textOverflow = "ellipsis";
                addrText.style.overflow = "hidden";
                addrText.title = option.address||'';
                var result = '无'
                if(option.warnField=='2'){
                    result = '超速'
                }
                addrText.innerHTML = '超速预警：' + result;
                div.appendChild(addrText);

                div.onclick = function(){}

                map.getPanes().labelPane.appendChild(div);
                
                return div;
            }
            ComplexCustomOverlay.prototype.draw = function(){
                var map = this._map;
                var pixel = map.pointToOverlayPixel(this._point);
                this._div.style.left = (pixel.x + 20) + 'px' ;
                this._div.style.top  = pixel.y  + 'px' ;
            }
            var allOverlay = this.map.getOverlays();
            for(var i=0;i<allOverlay.length;i++){
                if(allOverlay[i].toString()=="[object Overlay]"){
                    this.map.removeOverlay(allOverlay[i]);
                }
            }
            var gpsLi = obj.position;
            var myCompOverlay = new ComplexCustomOverlay(new BMap.Point(gpsLi.lng, gpsLi.lat),obj);
            this.map.addOverlay(myCompOverlay);
        },

        //监听时间
        timeChange(){
            this.getData()
        },
        //回看
        showTrail(){
            this.dingshi(this.playPoint)
        },
        //删除固定的覆盖物
        clearBaiDu(){
            var allOverlay = this.map.getOverlays();
            for(var i = 0;i<allOverlay.length;i++) {
                if(allOverlay[i].toString()=="[object Polyline]"){
                    this.map.removeOverlay(allOverlay[i]);
                }
            }
        },
        //回看加速/正常切换
        speedShow(){
            if(this.interval==100){
                this.interval = 15
                this.intervalName = '正常'
            }else{
                this.interval = 100
                this.intervalName = '加速'
            }
            if(this.trailDisable){
                var that = this
                clearInterval(this.timesOut)
                var pois = this.playPoint
                this.timesOut = setInterval(() => {
                    if(that.pointIndex<pois.length){
                        if(that.pointIndex==0){
                            console.log('回放开始！')
                            that.trailDisable = true
                        }
                        that.pointIndex++
                        that.curTime = that.dataPoint[that.pointIndex] && that.dataPoint[that.pointIndex].time||'回看中...'
                        that.play(that.pointIndex,pois)
                    }else{
                        console.log('回放结束！')
                        that.curTime = ''
                        that.trailDisable = false
                        clearInterval(that.timesOut)
                        that.pointIndex = 0
                    }
                    
                }, this.interval);
            }
        },
    },
}
</script>
<style scoped>
    .pump-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
    }
    .box-left{
        width: 8vw;
        height: 100%;
        overflow: auto;
        display: flex;
        flex-wrap: wrap;
    }
    .box-left-item{
        display: flex;
        width: 100%;
        height: 10vh;
        flex-wrap: wrap;
        margin-bottom: 1vh;
        padding: 0.5vh 1vh;
    }
    .box-left-item p{
        width: 100%;
        position: relative;
        height: 3vh;
        text-align: left;
        line-height: 3vh;
    }
    .box-left-item p.con{
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
    }
    .box-right{
        width: calc( 100% - 8.1vw );
        height: 100%;
        padding: 1vh 1vh 0;
        position: relative;
    }
    .box-r-head{
        width: 100%;
        height: 7vh;
        display: flex;
        align-content: center;
        align-items: center;
        background: #fff;
        border-radius: 5px;
        padding: 1vh 1vw;
    }
    .box-r-head *{
        margin-right: 1vw;
    }
    .box-r-con{
        width: 100%;
        height: calc( 100% - 7vh );
        display: flex;
        position: relative;
        padding: 1vh 0 0;
    }
    .r-con-left{
        width: 4vw;
        height: 100%;
        position: relative;
        background: #fff;
        padding: 2vh 0;
    }
    
    .r-con-map{
        width: calc( 100% - 4vw );
        height: 100%;
        position: relative;
    }
    .map-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .car-item{
        cursor: pointer;
        height: 3vh;
    }
    .car-item:hover,.car-item.cur{
        background: #358ADA;
        color: #fff;
    }
</style>
<style>
    .r-con-left .el-slider{
        height: 100%;
    }
    .r-con-left .el-slider.is-vertical .el-slider__marks-text{
        width: 4vh;
        font-size: 1vh;
    }
    .pump-box .el-collapse-item__header{
        height: 10vh;
    }
 @import '../../../assets/css/common.css';
</style>